import React, { useEffect, useState } from "react";
import { userRequest } from "../request";
import { useSelector } from "react-redux";
import DepartmentChart from "./DepartmentChart";

const Dashboard = () => {
  const user = useSelector((state) => state.user.user);
  const [stats, setStats] = useState(null);

  const getStats = async () => {
    try {
      const response = await userRequest(user.token).get("/stats");
      setStats(response.data);
    } catch (error) {
      console.error("Failed to fetch project stats:", error);
    }
  };

  useEffect(() => {
    getStats();
  }, []);

  const statsArray = stats
    ? [
        { title: "Total Projects", count: stats.total },
        { title: "Running", count: stats.running },
        { title: "Closed", count: stats.closed },
        { title: "Closure Delay", count: stats.closureDelayed },
        { title: "Cancelled", count: stats.cancelled },
      ]
    : [];

  return (
    <div className="dashboard w-full -z-20 ">
      <div className="flex lg:justify-between justify-center items-center flex-wrap lg:flex-nowrap gap-2 lg:gap-8 ">
        {statsArray?.map((item, index) => (
          <div
            key={index}
            className="flex bg-white  relative overflow-hidden shadow-md border lg:w-full w-28 rounded-md"
          >
            <div className="absolute start-0 w-1 bg-sky-400 h-full" />
            <div className="lg:ms-4 p-2 lg:pr-24">
              <h3 className="lg:text-nowrap text-xs">{item.title}</h3>
              <p className="text-3xl font-bold text-gray-600">{item.count}</p>
            </div>
          </div>
        ))}
      </div>

      <div className=" lg:mt-8">
        <DepartmentChart />
      </div>
    </div>
  );
};

export default Dashboard;
